'use strict'

/**
 * @foundation - SelfPosition
 * ===========================================
 */

import ClassEvent from '@/helpers/class.js'

export const SelfPositionOptions = {
  repeat: false,
  targetDataId: false,
  inViewClassName: 'is-screen'
}

export default class SelfPosition extends ClassEvent {
  constructor(targets, options) {
    super()

    this.targets = targets
    this.options = Object.assign({}, SelfPositionOptions, options)

    this.observer = false
    this.targetDatasetName = false

    this.setupElements()
  }

  setupElements() {
    this.targetDatasetName = (this.options.targetDataId) ? SelfPosition.convertToDataset(this.options.targetDataId) : false
    this.initIntersectionObserver()
  }

  destroy() {
    this.targetDatasetName = false
    this.destroyIntersectionObserver()
  }

  /**
   * Convert String to Dataset Format String
   *
   * @param {String} string
   * @param {Boolean} pascal
   */
  static convertToDataset(string = '', pascal = false) {
    const converter = (matches) => matches[1].toUpperCase()

    let result = string.replace(/(\-\w)/g, converter)

    if (pascal === true) {
      result = result.charAt(0).toUpperCase() + result.slice(1)
    }

    return result
  }

  /**
   * IntersectionObserverを使用して要素が画面内に存在するかを監視する
   */
  initIntersectionObserver() {
    const options = {
      rootMargin: '0px',
      threshold: 0.5
    }
    this.observer = new IntersectionObserver(
      this.intersectionObserverCallback.bind(this),
      options
    )
    this.targets.forEach(item => this.observer.observe(item))
  }

  /**
   * IntersectionObserverの監視を停止する
   */
  destroyIntersectionObserver() {
    this.targets.forEach(item => this.observer.unobserve(item))
  }

  /**
   * IntersectionObserverのコールバック - 要素に変化が起きた時のみ発火
   */
  intersectionObserverCallback(entries, object) {
    entries.forEach((entry, index) => {
      const dataId = entry.target.dataset[this.targetDatasetName] ? entry.target.dataset[this.targetDatasetName] : false

      if (!entry.isIntersecting) {
        // 画面外
        this.elementOutView(entry.target, dataId)
      } else {
        // 画面内
        this.elementInView(entry.target, dataId)
        if (!this.options.repeat) {
          this.observer.unobserve(entry.target)
        }
      }
    })
  }

  /**
   * 画面内にいる要素へクラスを追加
   *
   * @param {DOMElement} el
   * @param {Number} dataId
   */
  elementInView(el, dataId) {
    el.classList.add(this.options.inViewClassName)
    super.emit('in', el, dataId)
  }

  /**
   * 画面内にいる要素に追加したクラスを削除
   *
   * @param {DOMElement} el
   * @param {Number} dataId
   */
  elementOutView(el, dataId) {
    el.classList.remove(this.options.inViewClassName)
    super.emit('out', el, dataId)
  }
}
